import React from 'react';
import {
    Card, CardHeader, CardBody, CardFooter,
    CardLink, CardText,
    Modal, ModalBody, ModalFooter,
    Button
} from 'reactstrap';

import FileDownload from "components/Varios/FileDownload.js";

export default class CardAcuerdoMediosElectronicos extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
        };
    }

    toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen,
        });
    };

    onClick = change => {
        this.setState(
            {
                isOpen: !this.state.isOpen,
            },
            (() => { this.props.eventDelete() })
        );
    };

    parseDate(date) {
        if (date) {
            date = new Date(date)
            return date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear()
        }
        return null
    }

    parseYear(date) {
        if (date) {
            date = new Date(date)
            return date.getFullYear()
        }
        return null
    }

    download = (e) => {
        e.preventDefault();
        let name = e.target.parentNode.dataset.name;
        let url = e.target.parentNode.dataset.url;
        fetch(url)
            .then(response => {
                response.blob().then(blob => {
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    a.href = url;
                    a.download = name;
                    a.click();
                });
            });
    };

    function_color(numero) {
        var respuesta;

        var indice = (+(numero.split('/')[0]) - 1);
        var color = ["#65C400", "#00B1AB", "#FF7D00", "#FF7D9E", "#89509E", "#005DC0", "#0097DD", "#48BFB1", "#48BF6B", "#EABC3B"];

        if (+indice < 10) respuesta = color[+indice]
        else respuesta = color[+indice % 10]

        return respuesta;
    }

    render() {
        return (
            <div className="col-md-4 col-xs-4" style={{ paddingBottom: "15px" }}>
                <Card>
                    <CardHeader className="blanco text-center" style={{ backgroundColor: this.function_color(this.props.number) }}>
                        <b>ACUERDO DE MEDIOS ELECTRÓNICOS</b>
                    </CardHeader>
                    <CardBody>
                        <CardText>
                            
                            <br />
                            <span className="spanCard">FECHA DE ENVÍO: </span> {this.parseDate(this.props.objeto.fecharegistro)}
                            <br />
                            <span className="spanCard">ESTADO: </span> {this.props.objeto.estado}
                        </CardText>
                    </CardBody>
                    <CardFooter className="text-muted">
                        <div style={{ float: "left" }}>
                            {this.props.number}
                        </div>
                        <div style={{ float: "right" }}>
                            {this.props.evidencias.map((evidencia, idx) =>
                                <CardLink onClick={this.download} data-name={evidencia.name} data-url={evidencia.url} key={idx} href="#"><i className="fas fa-downloadx" aria-hidden="true"></i></CardLink>
                            )}
                            {this.props.objeto.estadorevisionth == 1 ?
                                (<CardLink onClick={this.toggle} href="#"><i className="fas fa-trash-altx" aria-hidden="true"></i></CardLink>)
                                : ('')}
                        </div>
                    </CardFooter>
                </Card>
                <Modal isOpen={this.state.isOpen} fade={false} toggle={this.toggle} >

                    <ModalBody>
                        ¿Está seguro que desea anular el registro?
                        </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={change => this.onClick(change)}>Aceptar</Button>{' '}
                        <Button color="primary" onClick={this.toggle}>Cancelar</Button>
                    </ModalFooter>

                </Modal>
            </div>
        )

    }
}